<form [formGroup]="dataForm" class="without-default-focus">
    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Etape</mat-label>
            <mat-select data-select-step formControlName="step" required tabindex="10" (selectionChange)="onStepChanged($event)">
                @for (item of _steps; track item) {
                    <mat-option data-select-listing-type-option [value]="item.data.id">
                        {{ item.data.stepName }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['step']?.required && (dataForm.controls['step']?.dirty || dataForm.controls['step'].touched)) {
                <mat-error data-input-role-error>Le champ 'Etape' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO Etape" matTooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-help">
        <mat-form-field class="with-info-icon">
            <mat-label>Etat</mat-label>
            <mat-select data-select-state formControlName="state" required tabindex="12">
                @for (item of _states; track item) {
                    <mat-option data-select-listing-type-option [value]="item.id">
                        {{ item.name }}
                    </mat-option>
                }
            </mat-select>
            @if (dataForm.errors && dataForm.errors['state']?.required && (dataForm.controls['state']?.dirty || dataForm.controls['state'].touched)) {
                <mat-error data-input-role-error>Le champ 'État' est obligatoire</mat-error>
            }
        </mat-form-field>
        <fa-icon [icon]="faCircleInfo" class="info-icon" matTooltip="TODO État" matTooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-help">
        <mat-checkbox class="with-info-icon accent-button" formControlName="activateStepIfNotStarted" tabindex="13">
            Activer l'étape si elle n'est pas encore démarrée.
        </mat-checkbox>
        <fa-icon
            [icon]="faCircleInfo"
            class="info-icon"
            matTooltip="Si cette option est activée, et que l'étape dont on désire changer l'état n'est pas activée alors l'étape sera activée avant que son état soit changé. Sinon cette action sera annulée"
            matTooltipPosition="right"></fa-icon>
    </div>

    <div class="form-item form-item-help">
        <mat-checkbox class="with-info-icon accent-button" formControlName="activateStepIfCompleted" tabindex="14">Activer l'étape si elle est terminée.</mat-checkbox>
        <fa-icon
            [icon]="faCircleInfo"
            class="info-icon"
            matTooltip="Si cette option est activée, et que l'étape dont on désire changer l'état est terminée alors l'étape sera re-activée avant que son état soit changé. Sinon cette action sera annulée"
            matTooltipPosition="right"></fa-icon>
    </div>
</form>
